import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {StructureBuiltInControl} from '../StructureBuiltInControl';

import {StructureAdaptControlLabels} from './StructureAdaptControlLabels';

export abstract class StructureAdaptBuiltInControl extends StructureBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.STRUCTURE].RESPONSIVE_STRUCTURE;
  }

  public getLabels(): StructureAdaptControlLabels | undefined {
    return undefined;
  }
}
